import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';

import { RoutingService } from 'src/app/services/routing.service';
import { LpHoldingDataService } from '../../../services/lp/lp-holding-data.service';
import { ImpersonationService } from '../../../services/shared/impersonation.service';
import { BaseResponseDto } from '../../../shared/models/BaseResponseDto.model';

@Component({
  selector: 'terra-lp-mobile-nav',
  templateUrl: './lp-mobile-nav.component.html',
  styleUrls: ['./lp-mobile-nav.component.scss']
})
export class LpMobileNavComponent {
  numberOfPortfolios$ = this.holdingDataService.getNumberOfPortfolios().pipe(
    catchError(error => {
      if (error instanceof BaseResponseDto) {
        return EMPTY;
      }

      throwError(error);
    }),
    shareReplay(1)
  );

  constructor(
    private router: Router,
    private holdingDataService: LpHoldingDataService,
    public routingService: RoutingService,
    private impersonationService: ImpersonationService
  ) {}

  public get isViewingAsInvestor(): boolean {
    return this.impersonationService.isViewingAsInvestor;
  }

  forceReloadOnSamePage(relativePath: string) {
    if (relativePath === this.router.url) {
      window.location.reload();
      return false;
    }
  }
}
